import React, { useEffect } from "react";
import { calFinalPrice } from "../../../../redux/action/buyerAction";
import { handleCalculateFinalPrice } from "../../../../redux/slice/buyerSlice";
import Shimmer from "../../../common/shimmer/Shimmer";
import { ACCOUNT } from "../../../../utils/constants";
import { useDispatch, useSelector } from "react-redux";
import useTranslationHook from "../../../hooks/useTranslationHook";
import { formatNumberByLocale } from "../../../../helpers";

export default function PriceCalculator({ property_id }) {
    const lang = useSelector((state) => state.translation.lang);
    const { t } = useTranslationHook();

    const dispatch = useDispatch();
    const account = useSelector((state) => state.profile.account);
    const buyerPriceCalculator = useSelector(
        (state) => state.buyer.buyerPriceCalculator
    );

    const calculateFinalPrice = () => {
        dispatch(calFinalPrice({ property_id: property_id }, t));
    };

    useEffect(() => {
        return () => {
            dispatch(handleCalculateFinalPrice({ reset: true }));
        };
    }, []);
    return (
        <>
            {!buyerPriceCalculator.show ? (
                <div className="price-calculator">
                    <h6>{t("Final price calculation")}</h6>
                    <button
                        className="btn btn-white btn-sm btn-full"
                        onClick={() => {
                            dispatch(handleCalculateFinalPrice({ show: true }));
                            calculateFinalPrice();
                        }}
                    >
                        {t("Calculate Final Price")}
                    </button>
                </div>
            ) : (
                <></>
            )}

            {buyerPriceCalculator.show ? (
                <div className="price-calculator">
                    <div className="accordion " id="accordionExample">
                        <div className="accordion-item">
                            <h6 className="accordion-header" id="headingOne">
                                <button
                                    className="accordion-button collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapseOne"
                                    aria-controls="collapseOne"
                                >
                                    {t("Final price calculation")}
                                </button>
                            </h6>
                            <div
                                id="collapseOne"
                                className="accordion-collapse collapse show"
                                aria-labelledby="headingOne"
                                data-bs-parent="#accordionExample"
                            >
                                <div className="accordion-body">
                                    {buyerPriceCalculator.dataLoading ? (
                                        <Shimmer
                                            type="rectangle"
                                            width="100%"
                                            height="20vh"
                                            margin-top="0"
                                            borderRadius="5%"
                                        ></Shimmer>
                                    ) : (
                                        <>
                                            {ACCOUNT.Buyer === account ? (
                                                <ul>
                                                    <li>
                                                        {t(
                                                            "Buyer premium amount"
                                                        )}
                                                        <span>
                                                            {" "}
                                                            {buyerPriceCalculator.buyers_premium ===
                                                            null ? (
                                                                <span>
                                                                    {t("NA")}
                                                                </span>
                                                            ) : (
                                                                <>
                                                                    <em className="dirham">
                                                                        D
                                                                    </em>{" "}
                                                                    {t(
                                                                        "Amount",
                                                                        {
                                                                            amount: formatNumberByLocale(
                                                                                buyerPriceCalculator.buyers_premium,
                                                                                lang
                                                                            ),
                                                                        }
                                                                    )}
                                                                </>
                                                            )}
                                                        </span>
                                                    </li>
                                                    <li>
                                                        {t("Platform fees")}
                                                        <span>
                                                            {buyerPriceCalculator.platform_fees ===
                                                            null ? (
                                                                <span>
                                                                    {t("NA")}
                                                                </span>
                                                            ) : (
                                                                <span>
                                                                    <em className="dirham">
                                                                        D
                                                                    </em>{" "}
                                                                    {t(
                                                                        "Amount",
                                                                        {
                                                                            amount: formatNumberByLocale(
                                                                                buyerPriceCalculator.platform_fees,
                                                                                lang
                                                                            ),
                                                                        }
                                                                    )}
                                                                </span>
                                                            )}
                                                        </span>
                                                    </li>
                                                    <li>
                                                        {t("VAT")}
                                                        {buyerPriceCalculator.taxes ===
                                                        null ? (
                                                            <span>
                                                                {t("NA")}
                                                            </span>
                                                        ) : (
                                                            <span>
                                                                <em className="dirham">
                                                                    D
                                                                </em>{" "}
                                                                {t("Amount", {
                                                                    amount: formatNumberByLocale(
                                                                        buyerPriceCalculator.taxes,
                                                                        lang
                                                                    ),
                                                                })}
                                                            </span>
                                                        )}
                                                    </li>
                                                    <li>
                                                        {t("Bid Price")}
                                                        {buyerPriceCalculator.current_bid ===
                                                        null ? (
                                                            <span>
                                                                {t("NA")}
                                                            </span>
                                                        ) : (
                                                            <span>
                                                                <em className="dirham">
                                                                    D
                                                                </em>{" "}
                                                                {t("Amount", {
                                                                    amount: formatNumberByLocale(
                                                                        buyerPriceCalculator.current_bid,
                                                                        lang
                                                                    ),
                                                                })}
                                                            </span>
                                                        )}
                                                    </li>
                                                    <li>
                                                        {t("Total")}
                                                        {buyerPriceCalculator.total_price ===
                                                        null ? (
                                                            <span>
                                                                {t("NA")}
                                                            </span>
                                                        ) : (
                                                            <span>
                                                                <em className="dirham">
                                                                    D
                                                                </em>{" "}
                                                                {t("Amount", {
                                                                    amount: formatNumberByLocale(
                                                                        buyerPriceCalculator.total_price,
                                                                        lang
                                                                    ),
                                                                })}
                                                            </span>
                                                        )}
                                                    </li>
                                                </ul>
                                            ) : (
                                                <ul>
                                                    <li>
                                                        {t("Auction commission amount")}
                                                        <span>
                                                            {buyerPriceCalculator.commission_amount ===
                                                            null ? (
                                                                <span>
                                                                    {t("NA")}
                                                                </span>
                                                            ) : (
                                                                <span>
                                                                    <em className="dirham">
                                                                        D
                                                                    </em>{" "}
                                                                    {t(
                                                                        "Amount",
                                                                        {
                                                                            amount: formatNumberByLocale(
                                                                                buyerPriceCalculator.commission_amount,
                                                                                lang
                                                                            ),
                                                                        }
                                                                    )}
                                                                </span>
                                                            )}
                                                        </span>
                                                    </li>
                                                    <li>
                                                        {t("Commission VAT")}
                                                        {buyerPriceCalculator.taxes ===
                                                        null ? (
                                                            <span>
                                                                {t("NA")}
                                                            </span>
                                                        ) : (
                                                            <span>
                                                                <em className="dirham">
                                                                    D
                                                                </em>{" "}
                                                                {t("Amount", {
                                                                    amount: formatNumberByLocale(
                                                                        buyerPriceCalculator.taxes,
                                                                        lang
                                                                    ),
                                                                })}
                                                            </span>
                                                        )}
                                                    </li>
                                                    <li>
                                                        {t("Hammer Price")}
                                                        {buyerPriceCalculator.current_bid ===
                                                        null ? (
                                                            <span>
                                                                {t("NA")}
                                                            </span>
                                                        ) : (
                                                            <span>
                                                                <em className="dirham">
                                                                    D
                                                                </em>{" "}
                                                                {t("Amount", {
                                                                    amount: formatNumberByLocale(
                                                                        buyerPriceCalculator.current_bid,
                                                                        lang
                                                                    ),
                                                                })}
                                                            </span>
                                                        )}
                                                    </li>
                                                    <li>
                                                        {t("Total")}
                                                        {buyerPriceCalculator.total_price ===
                                                        null ? (
                                                            <span>
                                                                {t("NA")}
                                                            </span>
                                                        ) : (
                                                            <span>
                                                                <em className="dirham">
                                                                    D
                                                                </em>{" "}
                                                                {t("Amount", {
                                                                    amount: formatNumberByLocale(
                                                                        buyerPriceCalculator.total_price,
                                                                        lang
                                                                    ),
                                                                })}
                                                            </span>
                                                        )}
                                                    </li>
                                                </ul>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <button
                        className="btn btn-white btn-sm btn-full"
                        onClick={calculateFinalPrice}
                    >
                        {t("Recalculate Final Price")}
                    </button>
                </div>
            ) : (
                <></>
            )}
        </>
    );
}
